import styled from 'styled-components';
import { Button } from 'ui-kit';

export const ConfirmDetailsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 64px 24px;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

export const ConfirmDetailsContent = styled.div`
  width: 100%;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (max-width: 768px) {
    gap: 24px;
    padding: 32px 24px;
  }
`;

export const ConfirmDetailsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ConfirmDetailsTitle = styled.p`
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: var(--gray-900, #101828);
  margin: 0;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ConfirmDetailsSubtitle = styled.p`
  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: var(--gray-700, #344054);
  margin: 0;

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ConfirmDetailsCard = styled.div`
  width: 100%;
  background: var(--White, #fff);
  border: 1px solid var(--gray-100, #eff1f5);
  border-radius: 16px;
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.1);
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 42px;

  @media screen and (max-width: 768px) {
    box-shadow: none;
    border: none;
    border-radius: 0;
    padding: 0;
    gap: 16px;
  }
`;

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const CheckboxLabel = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--gray-700, #344054);
  margin: 0;

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const CTARow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PrimaryButton = styled(Button)`
  &.MuiButton-root {
    background: var(--primary-400, #62d2d5) !important;
    border-color: var(--primary-400, #62d2d5) !important;
    color: var(--gray-900, #101828) !important;
    border-radius: 8px;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-transform: none;
    padding: 12px 20px;

    &.Mui-disabled {
      background: var(--primary-200, #c6f1f5) !important;
      border-color: var(--primary-200, #c6f1f5) !important;
      color: var(--primary-500, #29adaf) !important;
      opacity: 1;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      padding: 10px 16px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
